import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { GeoreferenceParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { GeoreferenceManagerV4 } from '~/components/upload/georeference-v4/georeference-manager';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const GEOREFERENCES_PAGE = graphql(`
  query UploadOutcropUpdateGeoreferencesPage($id: ID!) {
    outcropGet(id: $id) {
      id
      georeferences {
        ...georeferenceParts
      }
    }
  }
`);

export default function UpdateOutcropGeoreferencesPage() {
  return (
    <ApolloProviderV4>
      <UpdateOutcropGeoreferencesPageInner />
    </ApolloProviderV4>
  );
}

function UpdateOutcropGeoreferencesPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(GEOREFERENCES_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: GEOREFERENCES_PAGE,
      variables: { id: outcropId },
    },
  ]);

  const outcrop = data?.outcropGet;
  const georeferences = outcrop?.georeferences ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <GeoreferenceManagerV4
      georeferences={georeferences}
      parentType={GeoreferenceParentType.Outcrop}
      parentId={outcropId}
      refetchQueries={refetchQueries}
    />
  );
}
